export const INVALID_MIN_UPLOAD_MESSAGE = 'You must upload at least %s files.';
export const INVALID_MAX_UPLOAD_MESSAGE =
    'Exceeded the maximum limit of %s images.';
export const INVALID_MAX_SIZE_MESSAGE = '%s exceeds %sMB.';
export const INVALID_MIN_SIZE_MESSAGE = '%s subceeds %sMB.';
export const INVALID_FILE_EXTENSIONS_MESSAGE =
    'Invalid file format. The format should be %s.';
export const INVALID_FILE_NAMES_MESSAGE =
    'Invalid file name. The file name should not include %s';
export const INVALID_MIN_IMAGE_DIMENSIONS_MESSAGE =
    'Image dimension should be at least %sX%s pixels.';
export const INVALID_MAX_IMAGE_DIMENSIONS_MESSAGE =
    'Image dimension should be at smaller than %sX%s pixels.';
export const DEFAULT_FILE_UPLOAD_ERROR = 'Upload failed. Try again.';
export const INVALID_IMAGE_ORIENTATION_MESSAGE = 'Image must be %s.';
export const INVALID_TOTAL_UPLOAD_SIZE_MESSAGE =
    'Total file size exceeds server limit of %sMB.';

export const generateValidationMessage = (
    template: string,
    values: string[]
): string => {
    const replace = values.shift() ?? '';
    const message = template.replace(/%s/, replace);
    if (values.length) {
        return generateValidationMessage(message, values);
    }
    return message;
};
